import Queue from "nq-js";
const ENDPOINT = "/import";

class ImportUseCase {
  execute(file) {
    const options = {
      body: file,
      headers: { "Content-Type": "application/octet-stream" },
    };
    return new Queue.Rest().request("POST", ENDPOINT, options);
  }
}

export default ImportUseCase;
